import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "user_enterprises",
    object: "user_enterprise",
    header: [
      { text: "Nombre y Apellido", value: "completed_name" },
      { text: "Email", value: "email" },
      { text: "Foto de Perfil", value: "profile_picture", sortable: false },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    roles: ['admin_enterprise'],
    options: {
      sortBy: ["_id"],
      sortDesc: [false],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    getRoles({ commit }) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .get(config.api_url + "roles")
          .then((response) => {
            commit("success", { roles: response.data });
            resolve(response.data);
          })
          .catch((err) => {
            commit("error");
            reject(err);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
